import React from 'react';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';
import PowerGenerationSourceEnvironmentList from './PowerGenerationSourceEnvironmentList';

//redux

const PowerGenerationSourceEnvironment = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Operaciones', icon: 'icon-wrench' },
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Fuentes de Generación de Energía' links={breadcrumbLinks} icon={'icon-zap'} />
					<PowerGenerationSourceEnvironmentList/>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default PowerGenerationSourceEnvironment;
